import { Map } from "ol";
import { ILayerFactory } from "./ILayerFactory";
import ImageLayer from "ol/layer/Image";
import { ImageWMS } from "ol/source";
import { MapContextMenuItem } from "../MapContextMenuItem";
import { SelectedFeatureInfo } from "../SelectedFeatureInfo";
import { ODDataType } from "./IODLayerName";
import { ODZoneLayerName } from "./ODZoneLayerName";
import ImageWMSEx from "@/geoMap/net/ImageWMSEx";
import { LayerUtil } from "../util/LayerUtil"

/**
 * 最大ズームレベル
 */
const LAYER_MAX_ZOOMLEVEL: Record<ODDataType, number> = {
  Bゾーン: 18,
  市区町村: 18,
  都道府県: 18,
};

/**
 * 最小ズームレベル
 */
const LAYER_MIN_ZOOMLEVEL: Record<ODDataType, number> = {
  Bゾーン: 12,
  市区町村: 10,
  都道府県: 6,
};

/**
 * API通信用URL
 */
const URL_API = process.env.VUE_APP_XROAD_API_URL;

/**
 * ODゾーンレイヤのクラス
 */
export class ODZoneLayerFactory implements ILayerFactory {
  /**
   * 表示WMSレイヤ
   */
  private _wmsLayer: ImageLayer<ImageWMS>;

  /**
   * 表示WMSソース
   */
  private _wmsImageSource: ImageWMS;

  /**
   * 表示対象ODゾーンレイヤ
   */
  private _visibleLayer: ODZoneLayerName;

  /**
   * 地物属性の有無を取得
   */
  isFeatureInfo(): boolean {
    return false;
  }

  /**
   * 範囲地物属性の有無を取得
   */
  isRangeFeatureInfo(): boolean {
    return false;
  }

  /**
   * 右クリック処理の有無を取得
   */
  isRightClickInfo(): boolean {
    return false;
  }

  /**
   * レイヤ定義を取得
   * @param _map openLayers Mapクラス
   */
  getViewLayer(_map?: Map): ImageLayer<ImageWMS>[] {
    //WMSレイヤの取得
    this._wmsImageSource = new ImageWMSEx({
      url: URL_API,
      params: {
        LAYERS: "",
        EXCEPTIONS: "application/json",
      },
      ratio: 1,
      serverType: "geoserver",
      crossOrigin: "Anonymous",
    });
    this._wmsLayer = new ImageLayer({
      source: this._wmsImageSource,
    });

    return [this._wmsLayer];
  }

  /**
   * 地物情報を取得
   * @param _map 地図
   * @param _latitude クリック座標緯度
   * @param _longitude クリック座標経度
   * @param x クリック位置X
   * @param y クリック位置Y
   * @param width 地図幅
   * @param height 地図高さ
   * @param bBox 地図範囲（BBOX)
   */
  async getFeatureInfo(
    _map: Map,
    _latitude: number,
    _longitude: number,
    _x: number,
    _y: number,
    _width: number,
    _height: number,
    _bBox: number[]
  ): Promise<SelectedFeatureInfo[]> {
    return null;
  }

  /**
   * 右クリック処理
   * @param map 地図
   * @param latitude クリック座標緯度
   * @param longitude クリック座標経度
   * @param x クリック位置X
   * @param y クリック位置Y
   * @param width 地図幅
   * @param height 地図高さ
   * @param bBox 地図範囲（BBOX)
   */
  async getRightClickInfo(
    _map: Map,
    _latitude: number,
    _longitude: number,
    _x: number,
    _y: number,
    _width: number,
    _height: number,
    _bBox: number[]
  ): Promise<MapContextMenuItem[]> {
    return null;
  }

  /**
   * 指定範囲の地物を取得
   * @param _map 地図
   * @param bBox 地図範囲（BBOX)
   */
  async getRangeFeatureInfo(
    _map: Map,
    _bBox: number[]
  ): Promise<SelectedFeatureInfo[]> {
    return null;
  }

  /**
   * 表示状態のレイヤ数を返す
   */
  getVisibleLayerCount(): number {
    return this._wmsLayer?.getVisible() ? 1 : 0;
  }

  /**
   * レイヤの表示状態を設定
   * @param isVisible 表示有無
   * @param visibleLayer 対象レイヤ
   */
  setVisible(isVisible: boolean, visibleLayer: ODZoneLayerName) {
    if (isVisible) {
      if (visibleLayer) {
        this._visibleLayer = visibleLayer;
      }

      this._wmsImageSource.updateParams({
        LAYERS: this._visibleLayer.getLayerName(),
        CQL_FILTER: this._visibleLayer.getCqlFilterString(),
      });
      this._wmsLayer.setMaxZoom(
        LAYER_MAX_ZOOMLEVEL[this._visibleLayer.odDataType]
      );
      // ズームレベルがLAYER_MIN_ZOOMLEVELに等しいときは表示されるようにしたいため、-1する
      this._wmsLayer.setMinZoom(
        LAYER_MIN_ZOOMLEVEL[this._visibleLayer.odDataType] - 1
      );
      this._wmsImageSource?.refresh();
      this._wmsLayer?.setVisible(true);
    } else {
      this._wmsLayer?.setVisible(false);
    }
  }
  /**
   * 表示レイヤが存在するか判定
   */
   isVisibleLayer(_map:Map) {
    return LayerUtil.isVisibleLayer(_map, this._wmsLayer)
  }
}
